const api_url = "https://clairity-api-anj5gwymgq-uc.a.run.app/clairity";

export default api_url;